import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject, input, output } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter, Subscription, take, tap } from 'rxjs';
import { selectTenantFilterSearch, selectUserFilterSearch } from 'src/app/shared/store/reducers';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-text-search-filter[context]',
    template: `
    <mat-form-field appearance="outline">
      <mat-label>{{ 'SEARCH' | translate }}</mat-label>
      <input #searchField matInput [formControl]="search"/>
    </mat-form-field>
  `,
    styles: [`
    ::ng-deep .mat-mdc-form-field-subscript-wrapper {
      display: none;
    }
    `
    ],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class TextSearchFilterComponent implements OnInit, OnDestroy {
  private store = inject(Store);

  readonly searchTextChange = output<string>();

  readonly context = input.required<'tenant' | 'user'>();

  // @ViewChild("searchField") searchField!: ElementRef<HTMLInputElement>;

  search = new UntypedFormControl('');

  sub!: Subscription;

  ngOnInit(): void {
    // Initialize formControl value
    this.store
      .select(this.context() === 'tenant' ? selectTenantFilterSearch : selectUserFilterSearch)
      .pipe(filter(({ value }) => value !== this.search.value))
      .subscribe(({ value }) => this.search.setValue(value));

    // on form control value change, update store
    this.sub = this.search.valueChanges.pipe(tap((value) => this.searchTextChange.emit(value))).subscribe();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
